<template>
  <div style="background-color: rgb(249, 249, 249);  width: 100%;">
    <div class="d-flex justify-center">
      <v-btn color="indigo" small text class="d-flex justify-center" @click="handleGetMainHeight">
        <v-icon size="30" color="indigo">mdi-chevron-down</v-icon>
      </v-btn>
    </div>
    <div class="pt-16 pb-16">
      <YA_FewShotContent1 />
    </div>
    <!-- <div class="pt-16 pb-16">
      <YA_Customers />
    </div> -->
  </div>
</template>

<script>
import YA_FewShotContent1 from '@/components/PowerFewShot/YA_FewShotContent1.vue';

export default {
  name: 'PowerFewShotContent',
  components: {
    YA_FewShotContent1,
  },
  data() {
    return {

    }
  },
  mounted() {

  },

  methods: {
    handleGetMainHeight() {
      this.$store.commit('HandlepowerFewShotMainHeight', true);
    },
  }

};
</script>

<style scoped>

</style>